import { useEffect, useState } from "react"

import Threads from "../../components/BackgroundThreads/Threads"

import { useTranslation } from "react-i18next"
import { FaChevronRight, FaChevronDown } from "react-icons/fa6"

import { PieChart } from "react-minimal-pie-chart"
import toast from "react-hot-toast"

import { useBalance } from "../../hooks/useBalance"
import { useCoins } from "../../hooks/useCoins"
import { numberWithCommas, calculateTotalBalance, getFirstPairForAsset } from "../../utils/functions"
import { usePairs } from "../../hooks/usePairs"
import useModalStore from "../../stores/ModalStore"
import AssetModal from "../../modals/AssetModal/AssetModal"
import { PiHandDepositBold } from "react-icons/pi";
import { SiConvertio } from "react-icons/si";


import coinlogos from "../../utils/coinlogos"

import coincolors from "../../utils/coincolors"
import useAuthStore from "../../stores/AuthStore"
import axiosInstance from "../../api/axiosInstance"

import "./Wallet.css"
import AssetBox from "../../components/AssetBox/AssetBox"
import FillerBox from "../../components/FillerBox/FillerBox"

import card from "../../assets/logos/raincard.svg"
import { useNavigate } from "react-router-dom"
import { useCards } from "../../hooks/useCards"
import Spinner from "../../components/Spinner/Spinner"

const Wallet = () => {

    const { t } = useTranslation('common')

    const { data: balanceData } = useBalance()
    const { data: coinsData } = useCoins()
    const { data: pairsData } = usePairs()
    const { data: cardsData } = useCards()


    const hasCard = cardsData?.some((card: { status: string }) => card?.status === "active" || "")

    const [showSmallBalances, setShowSmallBalances] = useState(false)
    const [sortingParam,] = useState("")
    const [filterInput/* , setFilterInput */] = useState("")
    const [selectedCoin, setSelectedCoin] = useState("")
    const navigate = useNavigate()

    const toggleSmallBalances = () => {
        setShowSmallBalances((prev) => {
            return !prev
        })
    }



    const { setModalContent } = useModalStore((state) => {
        return {
            setModalContent: state.setModalContent
        }
    })

    let total_balance_usdt = calculateTotalBalance(coinsData, balanceData)

    const hasBalance = total_balance_usdt > 0
    let bigPercentageElems: JSX.Element[] = []
    let smallPercentageElems: JSX.Element[] = []
    let allPercentageElems: JSX.Element[] = []
    let chartData: any[] = []

    console.log(hasBalance)


    const sortListByIndex = (list: any[]) => {
        return list.sort(
            (a, b) => {
                return coinsData.coins[a].index - coinsData.coins[b].index
            }
        )
    }

    if (coinsData && balanceData) {
        let first = true
        sortListByIndex(Object.keys(coinsData.coins)).forEach((coin) => {
            const percentage = ((balanceData.balance[coin].actual + balanceData.balance[coin].orders) * coinsData.coins[coin].price * 100 / total_balance_usdt) || 0
            if (percentage > 0.1) {
                bigPercentageElems.push(
                    <div
                        key={coin}
                        onClick={() => { setSelectedCoin(coin) }}
                        className={`coin-percentage-cont ${selectedCoin === coin ? "coin-percentage-cont-selected" : ""}`}
                    >
                        <img className="percentage-logo" src={coinlogos[coin as keyof typeof coinlogos]} />
                        <span className="percentage-coin-name">{coin}</span><span className="coin-percentage">{percentage.toFixed(2)}%</span>
                    </div>
                )
                chartData.push({ key: coin, title: coin, value: percentage, color: coincolors[coin as keyof typeof coincolors] })
                if (!selectedCoin && first) {
                    setSelectedCoin(coin)
                    first = false
                }
            }
            else if (percentage > 0 && percentage < 0.1) {
                const elem = (
                    <div key={coin} className="small-balance-item-cont">
                        <img className="percentage-logo" src={coinlogos[coin as keyof typeof coinlogos]} />
                        <div className="amount-price-cont">
                            <div className="amount-cont">
                                <span className="currency-name">{coin}</span>
                                <span className="amount-value">{numberWithCommas(balanceData.balance[coin].actual + balanceData.balance[coin].orders, coinsData?.coins[coin]?.decimals)}</span>
                            </div>
                            <div className="price-cont">
                                <span className="currency-long-name">{t(`long_coin_names.${coin}`)}</span>
                                <span className="price-value">{numberWithCommas(coinsData.coins[coin].price * (balanceData.balance[coin].actual + balanceData.balance[coin].orders), 2)}</span>
                            </div>
                        </div>
                    </div>
                )
                smallPercentageElems.push(elem)
            }
            else {
                allPercentageElems.push(
                    <div
                        key={coin}
                        className="coin-percentage-cont coin-percentage-solid-cont"
                    >
                        <img className="percentage-logo" src={coinlogos[coin as keyof typeof coinlogos]} />
                        <span className="percentage-coin-name">{coin}</span>
                        <span className="coin-percentage">{percentage.toFixed(2)}%</span>
                    </div>)
            }
        })
    }

    const sortCoins = (coins: string[]) => {
        switch (sortingParam) {
            case 'amount':
                return [...coins].sort((a, b) => (balanceData.balance[b].actual + balanceData.balance[b].orders) - (balanceData.balance[a].actual + balanceData.balance[a].orders))
            case 'price':
                return [...coins].sort((a, b) => coinsData.coins[b].price - coinsData.coins[a].price)
            case 'change':
                return [...coins].sort((a, b) => coinsData.coins[b].price_24h - coinsData.coins[a].price_24h)
            case 'amount-desc':
                return [...coins].sort((a, b) => (balanceData.balance[a].actual + balanceData.balance[a].orders) - (balanceData.balance[b].actual + balanceData.balance[b].orders))
            case 'price-desc':
                return [...coins].sort((a, b) => coinsData.coins[a].price - coinsData.coins[b].price)
            case 'change-desc':
                return [...coins].sort((a, b) => coinsData.coins[a].price_24h - coinsData.coins[b].price_24h)
            default:
                return [...coins].sort((a, b) => coinsData.coins[a].index - coinsData.coins[b].index)
        }
    }

    const filteredCoins = () => {
        const coins = Object.keys(coinsData.coins)
        const capi = filterInput.toUpperCase()
        const filtered = coins.filter(function (str) { return str.includes(capi) })

        return sortCoins(filtered)
    }

    let coinsLen = coinsData ? Object.keys(coinsData.coins).length : 0
    const remainder = coinsLen % 3
    const needsFiller = remainder > 0

    const { isLogged } = useAuthStore((state) => ({
        isLogged: state.isLogged
    }))

    useEffect(() => {
        const eventCode = localStorage.getItem("eventCode")
        if (eventCode && isLogged) {
            registerForEvent(eventCode)
        }
    }, [isLogged])

    const registerForEvent = async (eventCode: string) => {
        try {
            const response = await axiosInstance.post(`/event/${eventCode}/register/`)
            if (response.status === 200) {
                toast.success(t('success_registration_raffle'))
                // Clear the eventCode from localStorage after successful registration
                localStorage.removeItem("eventCode")
            }
        } catch (err) {
            console.error("Failed to register for the event:", err)
            localStorage.removeItem("eventCode")
        }
    }

    return (
        
        <div className="outlet-page-main-cont">
            {(!cardsData || !balanceData  || !coinsData ) ? (                                        <div className="loading-spinner-container">
                                            <Spinner />
                                        </div>) : (
            hasBalance || hasCard ? (
                < div className="wallet-page-main-cont">

                    <div className="wallet-page-balance-cont">
                        <h1 className="wallet-title">{t('balance')}</h1>
                        <div className="wallet-balance-body">

                            < div className="wallet-balance-top-balance">
                                <p className="wallet-balance-total-balance-text">{t('equivalent_balance')}:</p>
                                <span className="wallet-balance-total-balance-number">{total_balance_usdt ? `${numberWithCommas(total_balance_usdt, 2)} USDT` : "0 USDT"}</span>
                            </div>
                            <div className="wallet-balance-bottom-data">
                                <div className="wallet-balance-chart">
                                    <PieChart
                                        data={chartData.length > 0 ? chartData : [{ value: 100, color: "var(--text-secondary)" }]}
                                        animate
                                        rounded
                                        animationDuration={500}
                                        lineWidth={15}
                                        segmentsStyle={{ cursor: 'pointer' }}
                                    />
                                    {selectedCoin && (
                                        <div className="wallet-balance-chart-tooltip">
                                            <img className="percentage-logo" src={coinlogos[selectedCoin as keyof typeof coinlogos]} />
                                            <span className="tooltip-title">{selectedCoin}</span>
                                            <span>{numberWithCommas(balanceData.balance[selectedCoin].actual + balanceData.balance[selectedCoin].orders, coinsData?.coins[selectedCoin]?.decimals)}</span>
                                            {selectedCoin !== "USDT" && <span className="tooltip-equivalent-value">{numberWithCommas(coinsData.coins[selectedCoin].price * (balanceData.balance[selectedCoin].actual + balanceData.balance[selectedCoin].orders), 2)} USDT</span>}
                                        </div>
                                    )}
                                </div>
                                <div className="wallet-balance-data-splitter">
                                    <div className="wallet-balance-coin-percentages-cont">
                                        {bigPercentageElems.length > 0 ? bigPercentageElems : allPercentageElems}
                                    </div>
                                    <div className="separator"></div>
                                    {
                                        smallPercentageElems.length > 0 && <span onClick={toggleSmallBalances} className="small-balances-text" >{t('small_balances')} {showSmallBalances ? <FaChevronDown className="small-balances-icon" /> : <FaChevronRight className="small-balances-icon" />}</span>
                                    }
                                    <div className="wallet-balance-small-balances-cont">
                                        {showSmallBalances && <div className="small-balances-cont">
                                            {smallPercentageElems}
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="wallet-page-assets-cont">
                        <div className="wallet-page-assets-cont">
                            <div className="wallet-assets-body">
                                <div className="asset-box-grid">
                                    {coinsData && balanceData && filteredCoins().map((coin) => (
                                        <AssetBox
                                            key={coin}
                                            coin={coin}
                                            coinsData={coinsData}
                                            balanceData={balanceData}
                                            pairsData={pairsData}
                                            coinlogos={coinlogos}
                                            t={t}
                                            setModalContent={setModalContent}
                                            numberWithCommas={numberWithCommas}
                                            filteredCoins={filteredCoins}
                                            AssetModal={AssetModal}
                                            getFirstPairForAsset={getFirstPairForAsset}
                                        />
                                    ))}
                                    {needsFiller && (
                                        <FillerBox />
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            ) : (
                <div className="wallet-page-no-balance-cont">
                    <div className="wallet-page-no-balance-card-request">
                        <div className="threads-background">
                            <Threads
                                amplitude={4}
                                distance={0.1}
                                enableMouseInteraction={true}
                            />
                        </div>

                        <div className="nobalance-card-place">
                            <img src={card} className="card-image" alt="Crypto Card" />
                        </div>

                        <div className="nobalance-card-text">
                            <div className="card-title">{t('one_card_all_crypto')}</div>
                            <button className="request-card-button" onClick={() => navigate("/cards")}>
                                {t('request_card')}
                            </button>
                        </div>
                    </div>

                    <div className="wallet-page-no-balance-action">
                        <div className="wallet-page-bring-crypto" onClick={() => navigate("/deposit/USDT")}>
                            <div className="action-text">{t('bring_crypto')}</div>
                            <div className="wallet-page-bring-crypto-icon">
                                < PiHandDepositBold size={50} color="var(--logo-primary)" />
                            </div>
                        </div>
                        <div className="wallet-page-bring-crypto" onClick={() => navigate("/support")}>
                            <div className="action-text">{t('any_question')}</div>
                            <div className="wallet-page-bring-crypto-icon">
                                <SiConvertio size={50} color="var(--logo-primary)" />
                            </div>
                        </div>
                    </div>
                </div>)
            )}
        </div >
    )
}

export default Wallet